// extracted by mini-css-extract-plugin
module.exports = {"delegatePropertModal":"Delegates_delegatePropertModal__11tjX","tableContainer":"Delegates_tableContainer__5e4pw"};